import { FC } from 'react'
import cn from './index.module.css'
import classNames from 'classnames'

export interface IBasicTextField {
  value: string
  placeholder?: string
  className?: string
  isInvalid?: boolean
  disabled?: boolean
  type?: 'password' | 'email' | 'tel'
  onChange: (value: string) => void
}

const BasicTextField: FC<IBasicTextField> = ({
  value,
  className,
  placeholder,
  isInvalid,
  disabled,
  type,
  onChange,
}) => {
  const setValue = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.value)

  return (
    <input
      className={classNames(cn.input, isInvalid && cn.invalid, className)}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={setValue}
      disabled={disabled}
    />
  )
}

export default BasicTextField
